import React from "react";
import { HiX } from "react-icons/hi";

const ViewTabs = ({ defaultViews, savedViews, isViewActive, onSelectView, onDeleteView, getViewBadge }) => (
  <div className="flex items-center gap-1 rounded-lg bg-gray-100 p-1">
    {[...defaultViews, ...savedViews].map((tab, index) => {
      const isDefault = defaultViews.some((t) => t._id === tab._id);
      return (
        <React.Fragment key={tab._id}>
          {index === defaultViews.length && savedViews.length > 0 && <div className="mx-1 h-4 w-px bg-gray-300" />}
          <div className={isDefault ? undefined : "group relative"}>
            <button
              type="button"
              className={`rounded-md px-3 py-1.5 text-sm font-medium transition-colors ${
                isViewActive(tab) ? "bg-white text-gray-800 shadow-sm" : "text-gray-600 hover:text-gray-800"
              }`}
              onClick={() => onSelectView(tab)}
              title={index < 9 ? `\u2318${index + 1}` : undefined}
            >
              {tab.name}
              {getViewBadge?.(tab)}
            </button>
            {!isDefault && (
              <button
                type="button"
                className="absolute -right-1 -top-1 hidden rounded-full bg-gray-200 p-0.5 text-gray-500 transition-colors hover:bg-gray-300 hover:text-gray-700 group-hover:block"
                onClick={(e) => {
                  e.stopPropagation();
                  onDeleteView(tab._id);
                }}
              >
                <HiX className="h-2.5 w-2.5" />
              </button>
            )}
          </div>
        </React.Fragment>
      );
    })}
  </div>
);

export default ViewTabs;
